import {
  useCallback, useEffect,
} from 'react';
import { useStorageService } from '~/_shared/utils/storageService';
import { useModal } from '~/modal/useModal.hook';
import { useUserDataUsagesSelector } from '~/store/userData/userData.selectors';

const SEEN_PREPARE_DATA_KEY = 'seenPrepareDataTutorial';

export const useEnsurePrepareDataTutorialModalFlag = () => {
  const mapCount = useUserDataUsagesSelector().createdMaps;
  const storageService = useStorageService();

  const hasSeenPrepareData = storageService.getLocalStorageItem(SEEN_PREPARE_DATA_KEY) !== null;

  useEffect(() => {
    if (mapCount && !hasSeenPrepareData) {
      // Set the flag for users who have maps, so they won't see the modal if they delete them later.
      storageService.setLocalStorageItem(SEEN_PREPARE_DATA_KEY, new Date().toISOString());
    }
  }, [mapCount, hasSeenPrepareData, storageService]);
};

export const useCreateNewMap = () => {
  const mapCount = useUserDataUsagesSelector().createdMaps;
  const storageService = useStorageService();
  const { openModal: openPrepareDataModal } = useModal('PrepareData');
  const { openModal: openCreateNewMapModal } = useModal('CreateNewMap');

  const hasSeenPrepareData = storageService.getLocalStorageItem(SEEN_PREPARE_DATA_KEY) !== null;

  const onCreateNewMap = useCallback(() => {
    if ((mapCount === 0) && !hasSeenPrepareData) {
      openPrepareDataModal();
      storageService.setLocalStorageItem(SEEN_PREPARE_DATA_KEY, new Date().toISOString());
    }
    else {
      openCreateNewMapModal({});
    }
  }, [hasSeenPrepareData, mapCount, openCreateNewMapModal, openPrepareDataModal, storageService]);

  return { onCreateNewMap };
};
